import { certificateElementType } from "~/enums/certificateElementType";
import CertificateDynamicInput from "./certificateDynamicInput";
import DynamicSignatureElement from "./concerns/dynamicSignatureElement";
import DynamicModeCertificateElement from "./dynamicCertificateElement";

export default class DynamicModeDynamicSignatureCertificateElement extends DynamicSignatureElement(DynamicModeCertificateElement) {
  type: certificateElementType = certificateElementType.DynamicModeDynamicSignature;

  clearRepeatableInputs() {
    //Check if its a nested
    if (this.isConfiguredToRepeatableInput && !this.isInRepeatable) {
      this.underlying_variable = null
    }
  }

  get isConfiguredToRepeatableInput(): boolean {
    const dynamicInputParent = this.dynamicInput?.parent
    return dynamicInputParent instanceof CertificateDynamicInput && dynamicInputParent.is_list
  }

  get dynamicInput() {
    return this.certificate.certificateDynamicInputsArrayDeep.find(x => x.client_id === this.underlying_variable)
  }

  get isInRepeatable(): boolean {
    return this.layoutElementContainer.is_repeatable && !!this.layoutElementContainer.repeatable_input_id
  }
}